<script setup lang="ts">
  import useLinkResolver from "@/lib/useLinkResolver.ts"
  import { inject } from "vue"
  import { useRouter as defaultUseRouter } from "vue-router"

  const props = defineProps<{
    to: string
    target?: string
  }>()

  const useRouter = inject("useRouter", defaultUseRouter)
  const { isAnchorElement, linkAttributes, correctedUrl, navigateToUrl } =
    useLinkResolver(props.to, useRouter())

  const onClick = async (event: MouseEvent) => {
    await navigateToUrl(event)
  }
</script>

<template>
  <component
    :is="isAnchorElement ? 'a' : 'router-link'"
    v-bind="linkAttributes"
    :to="correctedUrl"
    :target="props.target"
    @click="onClick"
  >
    <slot></slot>
  </component>
</template>
